<script setup>
import {computed, inject, toRef} from 'vue';
import {Field, useField} from 'vee-validate';
import {string} from 'yup';
import {defaultFieldProps} from '../helpers/defaultProps';
import {useDccsField} from '../composables/useDccsField';
import {useI18n} from 'vue-i18n';

const {t} = useI18n();

const props = defineProps({
    ...defaultFieldProps,

    rows: {
        type: [Number, String],
        default: null,
    },

    cols: {
        type: [Number, String],
        default: null,
    },
    fieldMax: {
        type: String,
        required: false,
        default: null,
    },
});

const emit = defineEmits(['update:modelValue']);

const busy = inject('busy');
const {normalizedRequired, labelText, normalizedCols, normalizedRows} = useDccsField(props);
const validationRules = computed(() => {
    let validator = string();

    if (normalizedRequired.value === true) {
        validator = validator.required('');
    }

    return validator;
});

const refName = toRef(props, 'name');
const {errorMessage, value, resetField} = useField(refName, validationRules);

resetField({
    value: '',
});

const uniqueId = (name) =>{
    let uniqueName = name;
    if(uniqueName) {
        uniqueName = uniqueName.toLowerCase().replace(/[^\x00-\x7F]/g, "").replace(/\s/g, "-");
        return uniqueName;
    }

    return "";
}
</script>

<template>
    <Field v-slot="{ field, meta, errors }" v-model="value" as="div" :name="name" :label="label"
           :rules="validationRules"
           class="merkur-field input-field textarea-field">
        <textarea
            v-bind="field"
            :id="uniqueId(name)"
            :name="name"
            :class="['merkur-textarea materialize-textarea merkur-input ', { 'has-error': meta.touched || errors.length }, { 'is-danger': meta.validated && !meta.valid  || errors.length }]"
            :placeholder="placeholder"
            :rows="normalizedRows"
            :cols="normalizedCols"
            :required="normalizedRequired"
            :disabled="busy"
            :maxlength="fieldMax > 0 ? fieldMax : ''"
        />
        <label v-if="label && label.length" class="merkur-label active" :for="uniqueId(name)">
            {{ labelText }}<template v-if="normalizedRequired">*</template>
        </label>
    </Field>
</template>
